export const APP_CONFIG = {
  MAX_INPUT_LENGTH: 1000,
  API_TIMEOUT: 30000,
  DEBOUNCE_DELAY: 300,
} as const;

export const API_ENDPOINTS = {
  TRANSFORM: '/transform',
} as const;

export const ERROR_MESSAGES = {
  NETWORK_ERROR: 'Network error. Please check your connection and try again.',
  SERVER_ERROR: 'Server error. Please try again later.',
  VALIDATION_ERROR: 'Please enter valid text to transform.',
  MAX_LENGTH_EXCEEDED: `Text must be less than ${APP_CONFIG.MAX_INPUT_LENGTH} characters.`,
  EMPTY_INPUT: 'Please enter some text to transform.',
} as const;

export const validateInput = (text: string): string | null => {
  if (!text || text.trim().length === 0) {
    return ERROR_MESSAGES.EMPTY_INPUT;
  }
  
  if (text.length > APP_CONFIG.MAX_INPUT_LENGTH) {
    return ERROR_MESSAGES.MAX_LENGTH_EXCEEDED;
  }
  
  return null;
};

export const copyToClipboard = async (text: string): Promise<boolean> => {
  try {
    await navigator.clipboard.writeText(text);
    return true;
  } catch (error) {
    console.error('Failed to copy text:', error);
    return false;
  }
};
